import { useCallback, useEffect, useState } from "react";
import { fetchFeeds } from "../api";
import { Feed } from "../types";

export interface UseFeedsResult {
  feeds: Feed[];
  isLoading: boolean;
  error: string | null;
  reload: () => void;
}

export function useFeeds(): UseFeedsResult {
  const [feeds, setFeeds] = useState<Feed[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    const abort = new AbortController();
    setIsLoading(true);

    fetchFeeds(abort.signal)
      .then((loaded) => {
        setFeeds(loaded);
        setError(null);
      })
      .catch((caught: Error) => {
        if (caught.name === "AbortError") return;
        setError(caught.message);
      })
      .finally(() => {
        if (!abort.signal.aborted) setIsLoading(false);
      });

    return () => abort.abort();
  }, [attempt]);

  const reload = useCallback(() => setAttempt((value) => value + 1), []);

  return { feeds, isLoading, error, reload };
}
